import { render, staticRenderFns } from "./goodsPop.vue?vue&type=template&id=5a4e6e95&scoped=true"
import script from "./goodsPop.vue?vue&type=script&lang=js"
export * from "./goodsPop.vue?vue&type=script&lang=js"
import style0 from "./goodsPop.vue?vue&type=style&index=0&id=5a4e6e95&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e6e95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4e6e95')) {
      api.createRecord('5a4e6e95', component.options)
    } else {
      api.reload('5a4e6e95', component.options)
    }
    module.hot.accept("./goodsPop.vue?vue&type=template&id=5a4e6e95&scoped=true", function () {
      api.rerender('5a4e6e95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/brandSelection/components/goodsPop.vue"
export default component.exports